type CurrentProjectionParams = {
  year: number;
  monthIndex: number;
  currentYear: number;
  currentMonth: number;
  currentProjectionValue: number;
  accumulatedDisbursement: number;
  previousCurrentProjection: number;
};

export const calculateLineCurrentProjection = ({
  year,
  monthIndex,
  currentYear,
  currentMonth,
  currentProjectionValue,
  accumulatedDisbursement,
  previousCurrentProjection,
}: CurrentProjectionParams): number => {
  if (year === currentYear && monthIndex === currentMonth) {
    return accumulatedDisbursement + currentProjectionValue;
  }

  if (year === currentYear && monthIndex > currentMonth) {
    return previousCurrentProjection + currentProjectionValue;
  }

  if (year > currentYear) {
    return monthIndex === 1 ? currentProjectionValue : previousCurrentProjection + currentProjectionValue;
  }

  return 0;
};
